<!-- header  -->
<header>
    <!-- main navigation  -->
    <div class="head-top bg-theme-dark">
        <div class="container">
            <div class="tm-wrap tm-topbar-content">
                <div class="tm-wrap-cell">
                    <ul class="top-contact">
                        <li>
                            <a href="mailto:sales@prismtextilemachinery.com">
                                sales&#64;prismtextilemachinery.com
                            </a>
                        </li>
                        <li>
                            <a href="https://maps.app.goo.gl/SHQFRU9HKaZzBKpT8" target="_blank">
                                Plot No. 84/1, Phase I, G.I.D.C., Vatva, Ahmedabad
                            </a>
                        </li>
                    </ul>
                </div>
                <div class="tm-wrap-cell tm-align-right">
                    <div class="themetechmount-social-links-wrapper">
                        <ul class="social-icons">
                            <li class="tm-social-facebook">
                                <a class="tooltip-top" target="_blank"
                                    href="https://www.facebook.com/Prism-Textile-Machinery-Pvt-Ltd-316908801691389">
                                    <i class="icofont-facebook font-16"></i>
                                </a>
                            </li>
                            <li class="tm-social-facebook">
                                <a class="tooltip-top" target="_blank"
                                    href="https://www.youtube.com/@prismtextilemachinery">
                                    <i class="icofont-youtube-play font-16"></i>
                                </a>
                            </li>
                            <li class="tm-social-facebook">
                                <a class="tooltip-top" target="_blank"
                                    href="https://www.linkedin.com/in/prismtextilemachinery">
                                    <i class="icofont-linkedin font-16"></i>
                                </a>
                            </li>
                            <li class="tm-social-facebook">
                                <a class="tooltip-top" target="_blank" href="https://twitter.com/prismtextile">
                                    <i class="icofont-twitter font-16"></i>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="main-navigation">
        <!-- container  -->
        <div class="container nav-w-fiexd">
            <!-- nav  -->
            <nav class="navigation">
                <div class="logo-pos position-relative">
                    <div class="logo-div">
                        <a routerLink="/" class="logo"><img src="assets/img/logo-prism.png"
                                class="img-fluid header-logo" alt="Prism logo image"></a>
                    </div>
                </div>
                <div class="menu">
                    <button class="menu-close"><i class="icofont-close"></i></button>
                    <ul class="menu-ul">
                        <li class="nav-list">
                            <a routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"
                                class="nav-link">
                                Home
                            </a>
                        </li>
                        <li class="nav-list">
                            <a href="javascript:void(0)" class="nav-link" routerLinkActive="active">
                                Company <i class="icofont-rounded-down"></i>
                            </a>
                            <div class="dp-menu">
                                <ul class="dp-ul">
                                    <li> <a [routerLink]="['/about-us']" class="dp-link">Profile</a></li>
                                    <li> <a [routerLink]="['/clients']" class="dp-link">Clients</a></li>
                                </ul>
                            </div>
                        </li>
                        <li class="nav-list">
                            <a href="javascript:void(0)" class="nav-link" routerLinkActive="active">
                                Products <i class="icofont-rounded-down"></i>
                            </a>
                            <div class="dp-menu">
                                <ul class="dp-ul">
                                    <li> <a [routerLink]="['/product', 'cotton']" class="dp-link">Cotton Machinery</a>
                                    </li>
                                    <li> <a [routerLink]="['/product', 'technical']" class="dp-link">Technical
                                            Machinery</a></li>
                                </ul>
                            </div>
                        </li>
                        <li class="nav-list">
                            <a href="javascript:void(0)" class="nav-link" routerLinkActive="active">
                                Customers <i class="icofont-rounded-down"></i>
                            </a>
                            <div class="dp-menu">
                                <ul class="dp-ul">
                                    <li> <a [routerLink]="['/testimonial']" class="dp-link">Testimonial</a></li>
                                    <li> <a [routerLink]="['/satisfaction']" class="dp-link">Satisfaction</a></li>
                                </ul>
                            </div>
                        </li>
                        <li class="nav-list">
                            <a routerLink="videos" routerLinkActive="active" class="nav-link">
                                Videos
                            </a>
                        </li>
                        <li class="nav-list">
                            <a routerLink="news" routerLinkActive="active" class="nav-link">
                                News & Events
                            </a>
                        </li>
                        <li class="nav-list">
                            <a routerLink="career" routerLinkActive="active" class="nav-link">
                                Career
                            </a>
                        </li>
                        <li class="nav-list">
                            <a href="assets/pdf/E-Catalogue.pdf" target="_blank" class="nav-link">
                                E-Catalogue
                            </a>
                        </li>
                        <li class="nav-list">
                            <a routerLink="contact-us" class="nav-link">
                                Contact Us
                            </a>
                        </li>
                    </ul>

                </div>
                <button class="toggle"><i class="icofont-navigation-menu"></i></button>
            </nav>
            <!-- nav end  -->
        </div>
        <!-- container end  -->
    </div>
    <!-- main navigation end  -->
</header>
<!-- header end  -->